import React, { useState, memo } from 'react';
import axios from 'axios';
import { Table, Container, Spinner, Button, Modal, Form } from 'react-bootstrap';
import apiUrl from '../const';
import { connect } from 'react-redux';

const formatFileSize = (size) => {
    if (size === undefined || size === null || size < 5000) {
        return '0 KB';
    }
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let unitIndex = 0;
    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex++;
    }
    return `${size.toFixed(2)} ${units[unitIndex]}`;
};

const formatFileSizeServer = (size) => {
    if (size === undefined || size === null) {
        return '0 KB';
    }
    size = size * 1000;
    if (size < 5000) {
        return '0 KB';
    }
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let unitIndex = 0;
    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex++;
    }
    return `${size.toFixed(2)} ${units[unitIndex]}`;
};

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} - ${hours}:${minutes}`;
};

const EspacoServidor = (props) => {
    const [folders, setFolders] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [activeFolder, setActiveFolder] = useState(null);

    const [showModal, setShowModal] = useState(false);
    const [selectedFolders, setSelectedFolders] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState(['C']);
    const [generatedCode, setGeneratedCode] = useState('');
    const [copied, setCopied] = useState(false);
    const [lastClickedFolderIndex, setLastClickedFolderIndex] = useState(null);

    const tableTemaEscuro = 'table-dark table-striped table-bordered table-hover';
    const theadTemaEscuro = '';
    const tbodyTemaEscuro = '';

    const tableTemaClaro = 'table-light table-striped table-bordered table-hover';
    const theadTemaClaro = '';
    const tbodyTemaClaro = '';

    const isDark = props.tema === 'escuro';

    const handleDelete = async (folderName, fileName) => {
        try {
            await axios.post(`${apiUrl}/AdmDeleteFile`, {
                folder: folderName,
                file: fileName
            });
            setFolders(prevFolders => {
                return prevFolders.map(folder => {
                    if (folder.name === folderName) {
                        return {
                            ...folder,
                            contents: folder.contents.filter(file => file.name !== fileName)
                        };
                    }
                    return folder;
                });
            });
            alert('Arquivo excluído com sucesso!');
        } catch (error) {
            console.error('Erro ao excluir o arquivo:', error);
            alert('Erro ao excluir o arquivo.');
        }
    };

    const fetchData = async () => {
        try {
            setIsLoading(true);
            const response = await axios.get(`${apiUrl}/pastasServidor`, {
                timeout: 99999999999999
            });
            setFolders(response.data);
            setIsLoading(false);
        } catch (error) {
            console.error('Erro ao buscar dados das pastas:', error);
            alert('Erro ao buscar dados das pastas. Verifique o console para mais detalhes.');
            setIsLoading(false);
        }
    };

    const toggleFolder = (index) => {
        setActiveFolder(prevIndex => (prevIndex === index ? null : index));
    };

    const getAllStatuses = () => {
        const statuses = new Set();
        folders.forEach(folder => {
            if (folder.contents) {
                folder.contents.forEach(file => {
                    if (file.status) statuses.add(file.status);
                });
            }
        });
        return Array.from(statuses).sort();
    };

    const handleOpenModal = () => {
        setSelectedFolders([]);
        setSelectedStatuses([]);
        setGeneratedCode('');
        setCopied(false);
        setLastClickedFolderIndex(null);
        setShowModal(true);
    };

    const handleToggleFolderClick = (folderName, index, e) => {
        if (e.shiftKey && lastClickedFolderIndex !== null) {
            const start = Math.min(lastClickedFolderIndex, index);
            const end = Math.max(lastClickedFolderIndex, index);
            const rangeNames = folders.slice(start, end + 1).map(f => f.name);
            const shouldSelect = !selectedFolders.includes(folderName);
            setSelectedFolders(prev =>
                shouldSelect
                    ? [...new Set([...prev, ...rangeNames])]
                    : prev.filter(f => !rangeNames.includes(f))
            );
        } else {
            setSelectedFolders(prev =>
                prev.includes(folderName)
                    ? prev.filter(f => f !== folderName)
                    : [...prev, folderName]
            );
        }
        setLastClickedFolderIndex(index);
    };

    const handleToggleAllFolders = () => {
        if (selectedFolders.length === folders.length) {
            setSelectedFolders([]);
        } else {
            setSelectedFolders(folders.map(f => f.name));
        }
    };

    const handleToggleStatus = (status) => {
        setSelectedStatuses(prev =>
            prev.includes(status)
                ? prev.filter(s => s !== status)
                : [...prev, status]
        );
    };

    const handleGenerateCode = () => {
        const lines = [];
        folders.forEach(folder => {
            if (!selectedFolders.includes(folder.name)) return;
            if (!folder.contents) return;
            folder.contents.forEach(file => {
                if (selectedStatuses.includes(file.status)) {
                    lines.push(`    await drive.copyFileDrive('${folder.name}', '${file.name}');`);
                }
            });
        });

        if (lines.length === 0) {
            setGeneratedCode('// Nenhum arquivo encontrado com os filtros selecionados');
        } else {
            setGeneratedCode(
                `const executaUpload = async () => {\n\n${lines.join('\n')}\n\n}\n\nexecutaUpload();`
            );
        }
        setCopied(false);
    };

    const handleCopyCode = () => {
        navigator.clipboard.writeText(generatedCode);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    if (isLoading) {
        return (
            <Container className="text-center my-5 border p-5 rounded-lg">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Carregando...</span>
                </Spinner>
                <p className="mt-3">Carregando dados, por favor aguarde...</p>
            </Container>
        );
    }

    if (folders.length === 0) {
        return (
            <Container className="text-center my-5 border p-5 rounded-lg">
                <Button
                    className={isDark ? '' : 'text-black'}
                    onClick={fetchData}
                    variant="primary"
                >
                    Carregar Arquivos
                </Button>
            </Container>
        );
    }

    return (
        <Container>
            {/* Botões de ação — aparecem só após carregar pastas */}
            <div className="d-flex justify-content-end gap-2 mb-3 mt-3">
                <Button variant="secondary" onClick={fetchData}>
                    Atualizar Lista
                </Button>
                <Button variant="success" onClick={handleOpenModal}>
                    Gerar Código de Upload
                </Button>
            </div>

            {folders.map((folder, index) => (
                <div
                    key={index}
                    className={`border ${isDark ? 'bg-dark text-white' : 'bg-white text-black'}`}
                >
                    <button
                        onClick={() => toggleFolder(index)}
                        className={`w-full text-left px-4 py-2 focus:outline-none ${
                            isDark
                                ? 'bg-dark text-white hover:bg-slate-700'
                                : 'bg-neutral-100 text-black hover:bg-neutral-200'
                        }`}
                    >
                        <span className="font-semibold">
                            <span
                                className="cursor-pointer hover:underline"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigator.clipboard.writeText(folder.name);
                                }}
                                style={{ whiteSpace: 'pre-wrap' }}
                            >
                                {folder.name}
                            </span>
                            {' - '}
                            {formatFileSize(folder.size)}
                        </span>
                        <span className="float-right">
                            {activeFolder === index ? '-' : '+'}
                        </span>
                    </button>

                    {activeFolder === index && (
                        <div className="px-4 py-2">
                            {folder.type === 'folder' && folder.contents && folder.contents.length > 0 ? (
                                <Table
                                    bordered
                                    className={`${
                                        isDark ? tableTemaEscuro : tableTemaClaro
                                    } text-center`}
                                >
                                    <thead className={isDark ? theadTemaEscuro : theadTemaClaro}>
                                        <tr>
                                            <th>Nome do Arquivo</th>
                                            <th>Status</th>
                                            <th>Tamanho (Server)</th>
                                            <th>Tamanho (DB)</th>
                                            <th>Última Modificação</th>
                                            <th>Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody className={isDark ? tbodyTemaEscuro : tbodyTemaClaro}>
                                        {folder.contents.map((file, fileIndex) => (
                                            <tr key={fileIndex}>
                                                <td>
                                                    <span
                                                        className="cursor-pointer hover:underline"
                                                        onClick={() => navigator.clipboard.writeText(file.name)}
                                                        style={{ whiteSpace: 'pre-wrap' }}
                                                    >
                                                        {file.name}
                                                    </span>
                                                </td>
                                                <td>{file.status}</td>
                                                <td>{formatFileSize(file.size)}</td>
                                                <td>{formatFileSizeServer(file.dbSize)}</td>
                                                <td>{formatDate(file.lastModified)}</td>
                                                <td>
                                                    <Button
                                                        className={isDark ? '' : 'text-black'}
                                                        variant="danger"
                                                        onClick={() => handleDelete(folder.name, file.name)}
                                                    >
                                                        Excluir
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <p className={isDark ? 'text-white' : 'text-black'}>
                                    Esta pasta está vazia ou é um arquivo.
                                </p>
                            )}
                        </div>
                    )}
                </div>
            ))}

            {/* Modal de geração de código */}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="lg"
                data-bs-theme={isDark ? 'dark' : 'light'}
            >
                <Modal.Header
                    closeButton
                    className={isDark ? 'bg-dark text-white border-secondary' : ''}
                >
                    <Modal.Title>Gerar Código de Upload</Modal.Title>
                </Modal.Header>

                <Modal.Body className={isDark ? 'bg-dark text-white' : ''}>
                    {/* Filtro de Status */}
                    <Form.Group className="mb-4">
                        <Form.Label>
                            <strong>Filtrar por Status</strong>
                        </Form.Label>
                        <div className="d-flex flex-wrap gap-3">
                            {getAllStatuses().map(status => (
                                <Form.Check
                                    key={status}
                                    type="checkbox"
                                    label={status}
                                    checked={selectedStatuses.includes(status)}
                                    onChange={() => handleToggleStatus(status)}
                                    id={`status-${status}`}
                                />
                            ))}
                        </div>
                    </Form.Group>

                    {/* Seleção de Pastas */}
                    <Form.Group className="mb-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <Form.Label className="mb-0">
                                <strong>Selecionar Pastas</strong>
                            </Form.Label>
                            <Button
                                size="sm"
                                variant={isDark ? 'outline-light' : 'outline-secondary'}
                                onClick={handleToggleAllFolders}
                            >
                                {selectedFolders.length === folders.length
                                    ? 'Desmarcar Todas'
                                    : 'Selecionar Todas'}
                            </Button>
                        </div>
                        <div
                            style={{ maxHeight: '200px', overflowY: 'auto' }}
                            className={`border rounded p-2 ${isDark ? 'border-secondary bg-secondary bg-opacity-10' : ''}`}
                        >
                            {folders.map((folder, idx) => (
                                <div
                                    key={folder.name}
                                    onClick={(e) => handleToggleFolderClick(folder.name, idx, e)}
                                    style={{ cursor: 'pointer', userSelect: 'none' }}
                                >
                                    <Form.Check
                                        type="checkbox"
                                        label={`${folder.name} — ${formatFileSize(folder.size)}`}
                                        checked={selectedFolders.includes(folder.name)}
                                        onChange={() => {}}
                                        id={`folder-${folder.name}`}
                                        style={{ pointerEvents: 'none' }}
                                    />
                                </div>
                            ))}
                        </div>
                    </Form.Group>

                    <Button variant="primary" onClick={handleGenerateCode} className="mb-3">
                        Gerar Código
                    </Button>

                    {generatedCode && (
                        <>
                            <Form.Group>
                                <Form.Label>
                                    <strong>Código Gerado</strong>
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={12}
                                    value={generatedCode}
                                    readOnly
                                    style={{ fontFamily: 'monospace', fontSize: '12px' }}
                                    className={isDark ? 'bg-secondary text-white border-secondary' : ''}
                                />
                            </Form.Group>
                            <Button
                                variant={copied ? 'success' : 'outline-success'}
                                onClick={handleCopyCode}
                                className="mt-2"
                            >
                                {copied ? 'Copiado!' : 'Copiar Código'}
                            </Button>
                        </>
                    )}
                </Modal.Body>

                <Modal.Footer className={isDark ? 'bg-dark text-white border-secondary' : ''}>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

const mapStateToProps = (state) => {
    return {
        tema: state.appReducer.tema,
    };
};

export default connect(mapStateToProps, null)(memo(EspacoServidor));
